import { ArrowDownRight } from "lucide-react";
import { openCalendly } from "@/lib/calendly";
import { StatusLED } from "@/components/infra";

export const HERO_SUBTITLE = "DCYB is the community and talent pipeline for the next generation of data centers. The facilities behind AI, cloud, and everything connected.";
const MARK_SRC = "/dcyb-mark-lg.webp";

export const HeroStatus = ({ testId, dark = false, className = "" }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-2 whitespace-nowrap font-mono-label text-[11px] !tracking-normal ${className}`}>
    <StatusLED color="#10B981" className="shrink-0" />
    <span className={dark ? "text-[#A3A8B1]" : "text-[#5F6168]"}>Status: <span className={dark ? "text-[#34D399]" : "text-[#078552]"}>Active</span></span>
  </span>
);

export const HeroHeadline = ({ testId, dark = false, lineBreak = true, className = "" }) => (
  <h1 data-testid={testId} className={`font-dcyb leading-[1.04] !tracking-normal text-balance ${className}`}>
    <span className={dark ? "text-dcyb-chrome-light" : "text-dcyb-outline"}>The Next Generation of{lineBreak && <br className="hidden sm:block" />}{" Digital Infrastructure"}</span>
  </h1>
);

export const HeroSubtitle = ({ testId, className = "" }) => (
  <p data-testid={testId} className={`text-lg md:text-xl leading-relaxed font-normal ${className}`}>{HERO_SUBTITLE}</p>
);

export const HeroActions = ({ prefix, dark = false, className = "" }) => (
  <div data-testid={`${prefix}-actions`} data-chat-safe-area className={`flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-3 sm:gap-4 w-full sm:w-auto ${className}`}>
    <a href="#book" onClick={openCalendly} data-testid={`${prefix}-book-meeting-btn`} className={`group ${dark ? "chrome-btn chrome-btn-glow-dark" : "chrome-btn-dark chrome-btn-dark-glow"} inline-flex items-center justify-center gap-2.5 font-mono-label text-xs !tracking-normal px-7 py-4 w-full sm:w-auto`}>
      <span className="live-dot" aria-hidden="true" />Book a Meeting
      <ArrowDownRight size={16} aria-hidden="true" className="transition-transform group-hover:translate-x-0.5 group-hover:translate-y-0.5" />
    </a>
    <a href="/get-involved" data-testid={`${prefix}-get-involved-btn`} className={`${dark ? "hero-glass-btn" : "chrome-btn"} inline-flex items-center justify-center gap-2 font-mono-label text-xs !tracking-normal px-7 py-4 w-full sm:w-auto`}>Get Involved</a>
  </div>
);

export const LogoMark = ({ testId, className = "", sweep = true }) => (
  <div data-testid={testId} className={`dcyb-mark ${sweep ? "dcyb-mark-sweep" : ""} ${className}`} style={{ "--mark-url": `url(${MARK_SRC})` }}>
    <img src={MARK_SRC} alt="DCYB logo mark: two server racks above a group of people" width="803" height="901" draggable="false" />
  </div>
);

export const HorizontalLogo = ({ testId, className = "" }) => (
  <img src="/dcyb-logo-horizontal.webp" alt="DCYB" data-testid={testId} width="1200" height="399" draggable="false" className={`w-auto max-w-full object-contain select-none ${className}`} />
);
